// Israel clock helpers for the evening-aware WhatsApp feature (Founder 14/10/26). Pure + client-safe (Intl only, no Node APIs);
// shared by the browser (greeting / reassurance note) and scripts/wa-worker.mjs (night hold). The DB server clock is pinned to
// America/New_York, so Israel time NEVER comes from NOW(): it comes from Intl with timeZone Asia/Jerusalem.
const IL = 'Asia/Jerusalem', NY = 'America/New_York';
const fmtCache = {};
const fmt = tz => fmtCache[tz] || (fmtCache[tz] = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }));
/** Wall-clock parts of an instant in a zone. */
export function zoneParts(d, tz = IL) {
  const o = {}; for (const p of fmt(tz).formatToParts(d)) if (p.type !== 'literal') o[p.type] = Number(p.value);
  return { y: o.year, mo: o.month, d: o.day, h: o.hour % 24, mi: o.minute, s: o.second };
}
export const israelMinutes = (d = new Date()) => { const p = zoneParts(d, IL); return p.h * 60 + p.mi; };
/** "19:15" -> minutes since midnight (null on garbage). */
export function parseHM(s) { const m = /^\s*(\d{1,2}):(\d{2})\s*$/.exec(String(s ?? '')); if (!m) return null; const h = +m[1], mi = +m[2]; return h > 23 || mi > 59 ? null : h * 60 + mi; }
/** Is `now` inside [start, end) in Israel time? Handles the midnight wrap (19:15 -> 07:30). */
export function isEveningWindow(now = new Date(), start = '19:15', end = '07:30') {
  const a = parseHM(start), b = parseHM(end); if (a == null || b == null) return false;
  const t = israelMinutes(now); return a <= b ? t >= a && t < b : t >= a || t < b;
}
/** 19:15-03:59 -> "ערב טוב"; 04:00-07:30 -> "בוקר טוב"; otherwise null. */
export function greetingNow(now = new Date()) {
  const t = israelMinutes(now);
  if (t >= 19 * 60 + 15 || t < 4 * 60) return 'ערב טוב';
  if (t >= 4 * 60 && t <= 7 * 60 + 30) return 'בוקר טוב';
  return null;
}
// Wall time in a zone -> the UTC instant (offset found by iteration; DST-safe).
function wallToInstant(y, mo, d, h, mi, tz) {
  const want = Date.UTC(y, mo - 1, d, h, mi, 0); let t = want;
  for (let i = 0; i < 3; i++) { const p = zoneParts(new Date(t), tz); const off = Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s) - t; t = want - off; }
  return new Date(t);
}
/** The next instant (strictly after `now`) at which the Israel clock reads `hm` ("08:00"). */
export function nextIsraelTime(now = new Date(), hm = '08:00') {
  const mins = parseHM(hm) ?? 480, p = zoneParts(now, IL), H = Math.floor(mins / 60), M = mins % 60;
  let c = wallToInstant(p.y, p.mo, p.d, H, M, IL);
  if (c.getTime() <= now.getTime()) { const n = new Date(Date.UTC(p.y, p.mo - 1, p.d + 1)); c = wallToInstant(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate(), H, M, IL); }
  return c;
}
/** An instant as the DB clock (America/New_York wall time): "YYYY-MM-DD HH:MM:SS", for DATETIME columns written next to NOW(). */
export function toDbNyString(d) { const p = zoneParts(d, NY), z = n => String(n).padStart(2, '0'); return `${p.y}-${z(p.mo)}-${z(p.d)} ${z(p.h)}:${z(p.mi)}:${z(p.s)}`; }
